var map = {
	"./logo__pc28.png": 9102,
	"./logo_dd28.png": 5272,
	"./logo_game_am.png": 7407,
	"./logo_game_k3.png": 5075,
	"./logo_game_pc28.png": 4772,
	"./logo_game_ssc.png": 5720,
	"./logo_game_tz.png": 123,
	"./logo_game_xg.png": 7218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2273;